import axios from '@/utils/axios';

export default {
  getList(data) {
    return axios.get(`/organization`, {
      params: {
        page: data.page,
        page_size: data.page_size,
        ...(data.key_search ? { key_search: data.key_search } : {}),
      },
    });
  },
  create (data) {
    return axios.post(`/organization`, data);
  },
  getDetail (data) {
    return axios.get(`/organization/${data.id}`);
  },
  update (data) {
    return axios.put(`/organization/${data.id}`, data);
  },
  delete (data) {
    return axios.delete(`/organization/${data.id}`);
  },
  getCollectionOrg(data) {
    return axios.get(`/organization/${data.id}/collections`)
  },
  getTemplateOrg(data) {
    return axios.get(`/organization/${data.id}/templates`)
  },
  settingTemplate(data) {
    return axios.post(`/organization/${data.id}/setting-template`, data)
  }
};